<template>
  <header class="header" id="header">
    <div class="container">
      <div class="header__inner">
        <div
          @click="$router.push({ path: `/${$route.params.lang}/` })"
          class="logo"
        >
          <a style="cursor: pointer" v-html="icons['logo']"></a>
        </div>
        <div class="toolbar">
          <div @click="openSearch" class="toolbar__item search-icon">
            <a style="cursor: pointer" v-html="icons['search']"></a>
          </div>
          <div class="toolbar__item">
            <div class="burger" id="burger">
              <div class="burger__line top"></div>
              <div class="burger__line mid"></div>
              <div class="burger__line bot"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav
      class="navigation"
      id="navigation"
      style="transform: translateX(100%);"
    >
      <div class="navigation__inner">
        <ul class="navigation__list">
          <li class="navigation__list-item">
            <a @click="openPage('products')" class="navigation__list-link"
              ><span class="container container--nav">
                {{ $root.translations["products"] }}
              </span></a
            >
          </li>
          <li
            :key="cat.id"
            v-for="cat of productCats"
            class="navigation__list-item"
          >
            <a @click="openCat(cat)" class="navigation__list-link">
              <span class="container container--nav">
                {{ cat.name }}
              </span></a
            >
          </li>
        </ul>
        <ul class="navigation__list navigation__list--sec">
          <li class="navigation__list-item">
            <a @click="openAllergens()" class="navigation__list-link"
              ><span class="container container--nav">
                {{ $root.translations["allergens_text"] }}
              </span></a
            >
          </li>
          <li class="navigation__list-item">
            <a @click="openAllergens2()" class="navigation__list-link"
              ><span class="container container--nav">
                {{ $root.translations["allergens_text_2"] }}
              </span></a
            >
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  data() {
    return {
      productCats: null,
      apiUrl: process.env.VUE_BACKEND_PROXY_URL,
      icons: {
        search:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"> <path d="M8,16a8,8,0,1,1,8-8V8A8,8,0,0,1,8,16ZM8,2A6,6,0,1,0,14,8V8A6,6,0,0,0,8,2Zm8.56,16-4.35-4.38,1.43-1.44L18,16.56Z" fill="#ed8b00"></path> </svg>',
        logo:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 43"> <path fill="#da291c" d="M0 0h107.28v35.32H0z"/> <path fill="#ed8b00" d="M0 37.08h107.28v5.3H0z"/> <path d="M22.54 12.41h3.37v13.15h-3.37zm9.26 6.75c1.33 0 2.29-.66 2.29-2s-.9-1.94-2.27-1.94h-1v4zm23.37 3.4h4.53v3h-8V12.41h3.42zm5.63-10.15h8.62v3h-5.25v2.18h5v2.76h-5v2.22h5.26v3H60.8zM90 18.73l4.65-6.32h-4.78l-4.31 6.05v-6.05h-4.18v13.15h4.18v-6.05L93 29.12a12.06 12.06 0 01-6.41 1.78A11.67 11.67 0 0174.7 19a11.89 11.89 0 1123.78 0A12.07 12.07 0 0196 26.37zm-52.57-2A4 4 0 0135 20.55l3.34 5h-4l-3.51-5.51v5.51h-3.36V12.41h4.21c3.69 0 5.74 1.46 5.74 4.35zm-21.66-1.44A3.56 3.56 0 0012.21 19a3.55 3.55 0 003.56 3.7A3.72 3.72 0 0019 20.84l2.6 1.71a6.73 6.73 0 01-5.87 3.24A6.7 6.7 0 018.81 19a6.7 6.7 0 016.89-6.8 6.68 6.68 0 015.9 3.22l-2.67 1.76a3.6 3.6 0 00-3.16-1.87zm29.29 0A3.56 3.56 0 0041.5 19a3.55 3.55 0 003.56 3.7 3.72 3.72 0 003.19-1.83l2.61 1.71A6.86 6.86 0 1145 12.18a6.68 6.68 0 015.9 3.22l-2.67 1.76a3.6 3.6 0 00-3.17-1.87z" fill="#fff"/> <path d="M111.56 43a2.47 2.47 0 112.44-2.47 2.42 2.42 0 01-2.44 2.47zm0-4.59a2.12 2.12 0 102.09 2.12 2.07 2.07 0 00-2.09-2.12zm-.5 2.32v1.05h-.36v-2.59h1a.77.77 0 01.88.77.74.74 0 01-.66.76l.75 1.07h-.43l-.73-1.05zm.67-1.19h-.67v.84h.67a.42.42 0 100-.84z" fill="#da291c"/> </svg> ',
      },
    };
  },
  mounted() {
    setTimeout(
      function() {
        this.getCats();
      }.bind(this),
      500
    );
  },
  components: {},
  methods: {
    getCats() {
      axios
        .get(`${this.$root.apiUrl}/getProductCats/${this.$route.params.lang}`)
        .then((response) => {
          this.productCats = response.data.cats;
        });
    },
    openPage(url) {
      document.getElementById("burger").click();
      this.$router.push({ path: `/${this.$route.params.lang}/${url}` });
    },
    openAllergens() {
      document.getElementById("burger").click();
      this.$router.push({
        path: `/${this.$route.params.lang}/products/?allergenShow=true`,
      });
      this.$root.showAllergenSelect = true;
      window.scrollTo(0, 0);
    },
    openAllergens2() {
      document.getElementById("burger").click();
      this.$router.push({
        path: `/${this.$route.params.lang}/allergens/?allergenShow=true`,
      });
      window.scrollTo(0, 0);
    },
    openCat(cat) {
      document.getElementById("burger").click();
      this.$router.push({
        path: `/${this.$route.params.lang}/products/?cat=` + cat.id,
      });
      window.scrollTo(0, 0);
    },
    openSearch() {
      this.$router.push({
        path: `/${this.$route.params.lang}/products/?searchShow=true`,
      });
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
.navigation {
  text-transform: uppercase;
}
</style>
